import EventstoreClient from '../eventstore-client/EventstoreClient';
import ServiceClient, { ServiceClientOptions } from './ServiceClient';

export class ServiceClientWithEventstore<T> extends ServiceClient {
  public EventStore: EventstoreClient<T>;
  constructor(sco: ServiceClientOptions) {
    super(sco);
    this.EventStore = new EventstoreClient(this.httpClient, this.baseUrl);
  }
}
